import React, { useState } from "react";
import NavigationBar from "@components/NavigationBar";
import Footer from "@components/Footer";
import { Route, Routes } from "react-router-dom";
import NotFoundPage from "@app/errors/NotFoundPage";
import WalletModal from "@components/modals/WalletModal";
import { ModalContextProvider } from "@contexts/ModalContext";
import HomePage from "@app/home/HomePage";
import CollectionPage from "@app/collection/CollectionPage";
import CollectionsPage from "@app/collection/CollectionsPage";
import CreateCollectionPage from "@app/collection/create/CreateCollectionPage";
import EditCollectionPage from "@app/collection/edit/EditCollectionPage";
import ProfilePage from "@app/profile/ProfilePage";
import EditProfilePage from "@app/profile/edit/EditProfilePage";
import CreateItemPage from "@app/item/create/CreateItemPage";
import { MintableItemPage } from "@app/mintable/MintableItemPage";
import { AlertDialogProvider } from "@contexts/AlertDialogContext";
import { ChainSelector } from "@app/examples/ChainSelector";
import { CoinsContextProvider } from "@contexts/CoinsContext";
import { TxModalProvider } from "@contexts/TxModalContext";
import { RegisterModal } from "@components/modals/RegisterModal";
import { AlertDialog } from "@components/alert-dialog/AlertDialog";
import { AccountContextProvider } from "@contexts/AccountContext";
import { TxModal } from "@components/tx-modal/TxModal";
import { TokensPage } from "@app/tokens/TokensPage";
import { ItemPage } from "@app/item/ItemPage";
import AdminPage from "@app/admin/AdminPage";
import { NftPage } from "@app/nft/NFTPage";
import BulkCreateItemPage from "@app/item/create/BulkCreateItemPage";
import UserPage from "@app/user/UserPage";
import EditItemPage from "@app/item/edit/EditItemPage";
import AirForceLunc from "@app/air-force-lunc/AirForceLunc";
import LuncZombies from "@app/lunc-zombies/LuncZombies";
import LaunchpadPage from "@app/launchpad/LaunchpadPage";

function App() {
  const [visible, setVisible] = useState(false);

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 300) {
      setVisible(true);
    } else if (scrolled <= 300) {
      setVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  window.addEventListener("scroll", toggleVisible);

  return (
    <AlertDialogProvider>
      <AccountContextProvider>
        <ModalContextProvider>
          <ChainSelector>
            <CoinsContextProvider>
              <TxModalProvider>
                <>
                  <NavigationBar />

                  {/* Route */}
                  <Routes>
                    <Route path="*" element={<NotFoundPage />} />
                    <Route index element={<HomePage />} />
                    <Route path="air-force-lunc" element={<AirForceLunc />} />
                    <Route path="lunc-zombies" element={<LuncZombies />} />
                    <Route
                      path="collection/:query"
                      element={<CollectionPage />}
                    />
                    <Route
                      path="collection/:query/edit"
                      element={<EditCollectionPage />}
                    />
                    <Route path="collections" element={<CollectionsPage />} />
                    <Route
                      path="collection/create"
                      element={<CreateCollectionPage />}
                    />
                    <Route path="profile" element={<ProfilePage />} />
                    <Route path="profile/edit" element={<EditProfilePage />} />
                    <Route path="item/:id" element={<ItemPage />} />
                    <Route path="item/create" element={<CreateItemPage />} />
                    <Route
                      path="item/create/bulk"
                      element={<BulkCreateItemPage />}
                    />
                    <Route
                      path="item/:id/mint"
                      element={<MintableItemPage />}
                    />
                    <Route path="item/:id/edit" element={<EditItemPage />} />
                    <Route
                      path="nft/:collectionQuery/:tokenId"
                      element={<NftPage />}
                    />
                    <Route path="tokens" element={<TokensPage />} />
                    <Route path="admin" element={<AdminPage />} />
                    <Route path="launchpad" element={<LaunchpadPage />} />
                    <Route path="user/:username" element={<UserPage />} />
                  </Routes>
                  {/* End Route */}

                  {/* Modals */}
                  <AlertDialog />
                  <TxModal />
                  <WalletModal />
                  <RegisterModal />
                  {/* End Modals */}

                  <Footer />
                </>
              </TxModalProvider>
            </CoinsContextProvider>
          </ChainSelector>
        </ModalContextProvider>
      </AccountContextProvider>
    </AlertDialogProvider>
  );
}

export default App;
